/* eslint-disable import/first, import/newline-after-import */

import 'components/resources/show/free-attribution-slidedown/free-attribution-slidedown';
import 'components/resources/show/download-popup/download-popup';
import 'components/resources/show/account-dunning-modals/account-dunning-modals';
import 'components/resources/show/post-purchase-banner/post-purchase-banner';
import 'components/resources/show/daily-limit-join-pro-modal/daily-limit-join-pro-modal';

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import DownloadButtonController from 'components/resources/show/download-btn/download-btn-controller';
EezyStimulusApplication.register('download-btn', DownloadButtonController);

import(/* webpackChunkName: "returning-signin-controller" */ 'components/sessions/login-form/returning-signin-controller')
  .then((controller) => {
    EezyStimulusApplication.register('returning-signin', controller.default);
  });

import DownloadButtonPricingController from 'components/resources/show/resource-show-sidebar-pricing/download-btn/download-btn-pricing-controller';
EezyStimulusApplication.register('download-btn-pricing', DownloadButtonPricingController);

import FreeAttributionSlidedownController from 'components/resources/show/free-attribution-slidedown/free-attribution-slidedown-controller';
EezyStimulusApplication.register('free-attribution-slidedown', FreeAttributionSlidedownController);

import PostPurchaseBannerController from 'components/resources/show/post-purchase-banner/post-purchase-banner-controller';
EezyStimulusApplication.register('post-purchase-banner', PostPurchaseBannerController);

import DownloadPopupController from 'components/resources/show/download-popup/download-popup-controller';
EezyStimulusApplication.register('download-popup', DownloadPopupController);

import DailyLimitJoinProModalController from 'components/resources/show/daily-limit-join-pro-modal/daily-limit-join-pro-modal-controller';
EezyStimulusApplication.register('daily-limit-join-pro-modal', DailyLimitJoinProModalController);

import FreeTrialDailyLimitModalController from 'components/resources/show/daily-limit-join-pro-modal/free-trial-daily-limit-modal-controller';
EezyStimulusApplication.register('free-trial-daily-limit-modal', FreeTrialDailyLimitModalController);
